import { API } from '@/utils/api'


export default {
  data() {
    return {
      sourceItems: [],
      sourceLoading: false,
    }
  },
  computed: {
    hasSource() {
      return this.field && this.field.source && this.field.source.type
    },
    sourceItemValue() {
      return this.field.source && this.field.source.value_field
        ? this.field.source.value_field
        : 'value'
    },
    sourceItemText() {
      return this.field.source && this.field.source.label_field
        ? this.field.source.label_field
        : 'label'
    },
    sourceDependsValue() {
      if (!this.field.source || !this.field.source.depends_on_field) {
        return null
      }
      return (this.siblingValues && this.siblingValues[this.field.source.depends_on_field]) || null
    },
  },
  methods: {
    loadSourceItems() {
      const src = this.field && this.field.source
      if (!src) {
        return
      }

      if (src.type === 'preset') {
        this.sourceItems = this.getPresetItems(src.preset)
        return
      }

      if (src.type === 'static') {
        this.sourceItems = src.items || []
        return
      }

      if (src.type === 'item') {
        if (!this.entityId) {
          this.sourceItems = []
          return
        }
        this.sourceLoading = true
        const params = { entity_id: this.entityId }
        if (src.filter) {
          Object.assign(params, src.filter)
        }
        API.call('/cms/item/list.json', params).then(r => {
          const items = (r.data && r.data.items) || []
          const vf = src.value_field || 'item_id'
          const lf = src.label_field || 'name'
          this.sourceItems = items.map(item => ({
            [vf]: item[vf],
            [lf]: item[lf],
          }))
        }).catch(() => {
          this.sourceItems = []
        }).finally(() => {
          this.sourceLoading = false
        })
        return
      }

      if (src.type === 'api') {
        this.sourceLoading = true
        const params = {}
        if (src.depends_on_field && this.sourceDependsValue) {
          params[src.depends_on_field] = this.sourceDependsValue
        }
        API.call(`/${src.service}/${src.method}.json`, params).then(r => {
          this.sourceItems = (r.data && r.data.items) || r.data || []
        }).catch(() => {
          this.sourceItems = []
        }).finally(() => {
          this.sourceLoading = false
        })
      }
    },
    getPresetItems(preset) {
      if (preset === 'currencies') {
        const currencies = this.$store.state.auth.currencies || []
        return currencies.map(c => ({ value: c, label: c }))
      }
      return []
    },
  },
}
